import request from '@/utils/request'

export function getInsuranceComplianceOverview () {
  return request({
    url: '/addon/insuranceCompliance/overview',
    method: 'get'
  })
}
